import {
  EnvironmentProviders,
  Provider,
  importProvidersFrom,
  isDevMode,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import {
  provideClientHydration,
  withIncrementalHydration
} from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { Health } from '@awesome-cordova-plugins/health';
import {
  IonicRouteStrategy,
  provideIonicAngular
} from '@ionic/angular/standalone';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import {
  provideNgxWebstorage,
  withLocalStorage,
  withNgxWebstorageConfig,
  withSessionStorage
} from 'ngx-webstorage';
import { AnalyticModule } from '../providers/analytic/analytic.module';
import { ApiModule } from '../providers/api/api.module';
import { AudioModule } from '../providers/audio/audio.module';
import { ErrorModule } from '../providers/error/error.module';
import { EventModule } from '../providers/event/event.module';
import { EventTrackingModule } from '../providers/event-tracking/event-tracking.module';
import { GraphQLModule } from '../providers/graphql/graphql.module';
import { i18nModule } from '../providers/i18n/i18n.module';
import { HttpInterceptorModule } from '../providers/interceptor/interceptor.module';
import { ProfileModule } from '../providers/profile/profile.module';
import { SentryModule } from '../providers/sentry/sentry.module';
import { SessionModule } from '../providers/session/session.module';
import { effects } from './app.effects';
import { reducers } from './app.reducers';
import { routes } from './app.routes';

export const providers: Array<EnvironmentProviders | Provider> = [
  { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  provideIonicAngular({
    mode: 'ios',
    // https://github.com/ionic-team/ionic-framework/issues/28876#issuecomment-2125393554
    useSetInputAPI: true,
    innerHTMLTemplatesEnabled: true
  }),
  { provide: Health, useValue: Health },
  provideNgxWebstorage(
    withNgxWebstorageConfig({}),
    withLocalStorage(),
    withSessionStorage()
  ),
  provideRouter(routes),
  provideStore(reducers),
  provideStoreDevtools({
    maxAge: 30, // Retains last 30 states
    logOnly: !isDevMode(), // Restrict extension to log-only mode
    autoPause: true, // Pauses recording actions and state changes when the extension window is not open
    trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
    traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
    connectInZone: true // If set to true, the connection is established within the Angular zone
  }),
  provideEffects(effects),
  importProvidersFrom(
    HttpInterceptorModule,
    GraphQLModule,
    SessionModule,
    AnalyticModule,
    EventModule,
    i18nModule,
    ApiModule,
    EventModule,
    EventTrackingModule,
    ProfileModule,
    ErrorModule,
    AudioModule,
    SentryModule
  ),
  provideZoneChangeDetection(),
  // provideZonelessChangeDetection(),
  provideBrowserGlobalErrorListeners(),
  provideClientHydration(withIncrementalHydration())
];
